import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import {loginBroker, registerWithGoogle} from "../api/accounts";
import {brokerSession} from "../session/brokerSession";
import "../styles/brokerage.css";

const GoogleIcon = () => (
    <svg className="broker-btn__google-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path fill="#4285F4"
              d="M23.745 12.27c0-.79-.07-1.54-.19-2.27h-11.3v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z"/>
        <path fill="#34A853"
              d="M12.255 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96h-3.98v3.09C3.515 21.3 7.615 24 12.255 24z"/>
        <path fill="#FBBC05"
              d="M5.525 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62h-3.98a11.86 11.86 0 0 0 0 10.76l3.98-3.09z"/>
        <path fill="#EA4335"
              d="M12.255 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C18.205 1.19 15.495 0 12.255 0c-4.64 0-8.74 2.7-10.71 6.62l3.98 3.09c.95-2.85 3.6-4.96 6.73-4.96z"/>
    </svg>
);

const CLIENT_ID = process.env.REACT_APP_PHONE_EMAIL_CLIENT_ID || "11133177995114758829";

/**
 * Broker login page: authenticates via mobile OTP (phone.email widget) or
 * Google sign-in, then stores the returned session token before routing to
 * the broker dashboard.
 */
const LoginPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const scriptLoadedRef = useRef(false);

    useEffect(() => {
        window.phoneEmailListener = async (userObj) => {
            setLoading(true);
            setError("");
            try {
                const res = await loginBroker(userObj.user_json_url);
                brokerSession.set(res.token);
                navigate("/broker/dashboard", {replace: true});
            } catch (err) {
                setError(err.message || "Login failed. Please try again.");
            } finally {
                setLoading(false);
            }
        };

        if (!scriptLoadedRef.current) {
            const script = document.createElement("script");
            script.src = "https://www.phone.email/sign_in_button_v1.js";
            script.async = true;
            script.onload = () => { scriptLoadedRef.current = true; };
            document.body.appendChild(script);
        }

        return () => { window.phoneEmailListener = undefined; };
    }, [navigate]);

    useEffect(() => {
        if (brokerSession.get()) navigate("/broker/dashboard", {replace: true});
    }, [navigate]);

    return (
        <div className="broker-page">
            <div className="broker-header">
                <h1 className="broker-header__title">Agent/Developer Login</h1>
                <p className="broker-header__subtitle">Sign in with your registered mobile number</p>
            </div>

            <div className="broker-card">
                {error && <p className="broker-otp__error">⚠ {error}</p>}
                {loading && (
                    <p style={{fontSize: "0.82rem", color: "var(--broker-blue-mid)", marginBottom: 8}}>
                        Signing you in…
                    </p>
                )}

                <p className="broker-otp__hint">
                    Click below and verify your mobile number to sign in.
                </p>
                <div className="pe_signin_button" data-client-id={CLIENT_ID}/>

                <div className="broker-btn-group" style={{marginTop: 18}}>
                    <button className="broker-btn broker-btn--google" onClick={registerWithGoogle}>
                        <GoogleIcon/> Continue with Google
                    </button>
                </div>

                <p style={{marginTop: 16, fontSize: "0.85rem", textAlign: "center"}}>
                    Not registered yet?{" "}
                    <span className="broker-terms__link" onClick={() => navigate("/broker/register")}>
                        Register here
                    </span>
                </p>
            </div>
        </div>
    );
};

export default LoginPage;
